import * as ko from "knockout";
import { when } from "jquery";
import { WorkItemStatusIds } from "./constants/work-item-status-ids";
import Bao from "./../services/bao-service";
import BaoDialog, { DialogButton } from "./../factories/bao-dialog";
import baoRouter from "./../services/bao-router";
import baoShouter from "./../services/bao-shouter";
import BaseViewModel from "./../factories/base-view-model2";
import TabController from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
import WorkItemSerialDialog from "./dialogs/work-item-serial-dialog";
import WorkItemSerialDialogViewModel from "./dialogs/work-item-serial-dialog-view-model";
import WorkItemCollectionDialog from "./dialogs/work-item-collection-dialog";
import { WorkItemTypes } from "../constants/work-item-types";
import WorkItemTypeDialog from "./dialogs/work-item-type-dialog";
import Guid from "./../factories/guid";
import BaoMenu from "./../services/bao-menu";
import WorkItemObjectTab from "./tabs/work-item-object-tab";
import { WorkItemTabIds } from "./constants/work-item-tab-ids";

// WorkItem/Task ViewModel class for add/edit
class WorkItem extends BaseViewModel {
    // #region Constructor

    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.SettingsKeyPermissionApplicationId(window.SynosetApplicationId);

        this.WorkItemCollectionSelectedId.subscribe((value) => {
            if (value) {
                this.WorkItemCollectionId(value);                
                this.TabPage.IsLoading(true);
                $.when(this.SetPermissions())
                    .then(_ => this.TabPage.IsLoading(false));
            }
            else {
                if (this.TabPage.UrlData().WorkItemCollectionId) {
                    this.WorkItemCollectionSelectedId(this.TabPage.UrlData().WorkItemCollectionId);
                }
                else {
                    this.TabPage.IsLoading(true);
                    this.SetPermissions()
                        .then(_ => this.TabPage.IsLoading(false));;
                }
            }
        });
        this.TabPage.UrlData.subscribe((value) => {
            if (value.WorkItemCollectionId && this.WorkItemCollectionId() != value.WorkItemCollectionId
                && value.WorkItemCollectionId !== 'null'
                && this.WorkItemCollections().find(o => o.WorkItemCollectionId == value.WorkItemCollectionId)) {
                this.WorkItemCollectionSelectedId(value.WorkItemCollectionId)
            }
        });
        this.StartDateHtml.subscribe((value: string) => {
            if (value !== "" && this.EndDateHtml() !== "" && parseInt(value) > parseInt(this.EndDateHtml())) {
                this.EndDateHtml(value);
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgEndDateStartDateValidation"), "info");
            }
        });

        this.EndDateHtml.subscribe((value: string) => {
            if (value !== "" && this.StartDateHtml() !== "" && parseInt(this.StartDateHtml()) > parseInt(value)) {
                this.EndDateHtml(this.StartDateHtml());
                let baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgEndDateStartDateValidation"), "info");
            }
        });

        this.WorkItemPriority.subscribe((workItemPriority) => {
            this.Priority(workItemPriority?.WorkItemPriority);
        });

        this.TabPage.MenuEvents.push(this.Menu.registerEvent((btnClicked) => {
            if (this.TabPage.IsActiveTab() !== true) {
                return;
            }
            switch (btnClicked.ActionKey()) {
                case "WorkItemInProgress":
                    this.WorkItemInProgress();
                    break;
                case "WorkItemComplete":
                    this.WorkItemComplete();
                    break;
            }
        }));

        this.WorkItemCategory.subscribe((workItemCategory) => {
            this.Category(workItemCategory?.WorkItemCategory);
        });


        this.WorkItemTypeId.subscribe((value) => {
            if (value) {
                this.loadWorkItemTabs(value);
            }
        });

        this.WorkItemTabsCollection.subscribe((value) => {
            if (value && value.length > 0) {
                this.TabController.DestroyAll();

                ko.utils.arrayForEach(value, (tab, index) => {
                    let tabPageTemp: TabPage = new TabPage(null);
                    tabPageTemp.IsClosable(false);
                    tabPageTemp.Url(tab.WebUrl);
                    tabPageTemp.AutoSelect = (index == 0);
                    tabPageTemp.Title(tab.WorkItemTabName);
                    tabPageTemp.Id(tab.WorkItemTabId);

                    this.TabController.AddTab(tabPageTemp);
                });

                this.AddInitialConfigurationItem();
            }
        });

        this.AuditEvaluationName.subscribe((value: any) => {
            if (typeof value == 'string' || value == null) {
                this.AuditEvaluation(value);
            }
            else {
                this.AuditEvaluation(value.ListName);
            }
        })
    }

    
    //this eventhandler must be declared before its initialization open the workitemcollection page
    GoToWorkItemCollection = () => {
        if (this.WorkItemCollectionId() !== undefined && this.WorkItemCollectionId() !== null) {
            baoRouter.setHash("#workItemcollection/" + this.WorkItemCollectionId());
        }
    }
    // #endregion Constructor

    // #region Properties

    StartDateHtml: KnockoutObservable<string> = ko.observable();
    EndDateHtml: KnockoutObservable<string> = ko.observable();
    WorkItemLabels: KnockoutObservableArray<any> = ko.observableArray([]);
    Title: KnockoutObservable<string> = ko.observable();
    Description: KnockoutObservable<string> = ko.observable();
    Solution: KnockoutObservable<string> = ko.observable();
    SelectedLabels: KnockoutObservableArray<any> = ko.observableArray([]);
    WorkItemTag: KnockoutObservableArray<any> = ko.observableArray([]).extend({ dirty: this.TabPage.DirtyFlag });
    WorkItemId: KnockoutObservable<string> = ko.observable();
    WorkItemStatusId: KnockoutObservable<string> = ko.observable();

    WorkItemCategoryId: KnockoutObservable<string> = ko.observable();
    Category: KnockoutObservable<string> = ko.observable();
    WorkItemCategory: KnockoutObservable<any> = ko.observable();

    WorkItemPriorityId: KnockoutObservable<string> = ko.observable();
    Priority: KnockoutObservable<string> = ko.observable();
    WorkItemPriority: KnockoutObservable<any> = ko.observable();
    /**
     * Name of the workitemcollection
     * */
    WorkItemCollectionName: KnockoutObservable<string> = ko.observable();
    WorkItemCollectionId: KnockoutObservable<string> = ko.observable();
    WorkItemCollectionSelectedId: KnockoutObservable<string> = ko.observable();
    WorkItemCollections: KnockoutObservableArray<{
        WorkItemCollectionId: string;
        Title: string
    }> = ko.observableArray([]);

    WorkItemTypeId: KnockoutObservable<string> = ko.observable();
    /**
    * Name of work item type
    */
    WorkItemTypeName: KnockoutObservable<string> = ko.observable();
    TabControllerAssignment: TabController;
    AssignmentTab: TabPage;
    SerialTaskDialogViewModel: WorkItemSerialDialogViewModel;

    PrimaryWorkItemId: KnockoutObservable<string> = ko.observable();
    IsBasedOnVirtual: KnockoutObservable<boolean> = ko.observable();
    LeadTime = ko.observable<number>(0);

    /**
     * Id of the assigned checklist template
     */
    WorkItemFolderStructureChecklistId: KnockoutObservable<string> = ko.observable<string>();

    /**
     * Name of the assigned checklist template
     */
    WorkItemFolderStructureChecklistName: KnockoutObservable<string> = ko.observable<string>();

    //Evaluation Objekt, Name and Id for Audit WorkItems
    AuditEvaluation: KnockoutObservable<string> = ko.observable();
    AuditEvaluationName: KnockoutObservable<string> = ko.observable();
    AuditEvaluationId: KnockoutObservable<string> = ko.observable();


    /**
     * Key-Number value of work item in collection
     */
    KeyNumber: KnockoutObservable<string> = ko.observable();

    WorkItemPrioritySearcher: Bindings.baoSearcher = {
        ObjectId: this.WorkItemPriorityId,
        ObjectValue: 'WorkItemPriority',
        SearchType: 'WorkItemPriority',
        SelectedItem: this.WorkItemPriority,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { WorkItemTypeId: this.WorkItemTypeId }
    };

    WorkItemCategorySearcher: Bindings.baoSearcher = {
        ObjectId: this.WorkItemCategoryId,
        ObjectValue: 'WorkItemCategory',
        SearchType: 'WorkItemCategory',
        SelectedItem: this.WorkItemCategory,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { WorkItemTypeId: this.WorkItemTypeId }
    };
    /**
     * Searcher for the workitemcollection
     * */
    WorkItemCollectionSearcher: Bindings.baoSearcher = {
        ObjectId: this.WorkItemCollectionId,
        ObjectValue: 'WorkItemCollectionName',
        SelectedItem: this.WorkItemCollectionName,
        AutoComplete: true,
        AutoSearch: true,
        GotoVisible: true,
        Goto: this.GoToWorkItemCollection,
        Enabled: false,
        SearchType: ""
    }


    //this eventhandler must be declared before its initialization
    GoToEvaluation = () => {
        if (this.AuditEvaluationId() != "") {
            baoRouter.setHash("#checkware/evaluation/" + this.AuditEvaluationId());
        }
    }

    AuditEvaluationSearcher: Bindings.baoSearcher = {
        ObjectId: this.AuditEvaluationId,
        SelectedItem: this.AuditEvaluationName,
        AutoComplete: true,
        AutoSearch: true,
        GotoVisible: true,
        Goto: this.GoToEvaluation,
        Enabled: false,
        ObjectValue: "ListName",
        SearchType: "Checkware-Evaluation"
    }

    // Set/Check permission for Change Task Status
    IsTaskStatusChangePermission: KnockoutObservable<boolean> = ko.observable(false);

    // Check if WorkItem Status is InProgress
    IsInProgress: KnockoutObservable<boolean> = ko.observable(false);

    // Check if WorkItem Status is Completed
    IsCompleted: KnockoutObservable<boolean> = ko.observable(false);

    // User Name who Completed Task
    CompletedByName: KnockoutObservable<string> = ko.observable();

    // Formatted Completed date of workitem
    CompletedDateFormatted: KnockoutObservable<string> = ko.observable();

    // InProgress date of workitem
    InProgressDate: KnockoutObservable<string> = ko.observable();

    InProgressByName: KnockoutObservable<string> = ko.observable();

    // Formated InProgress date of workitem
    InProgressDateFormatted: KnockoutObservable<string> = ko.observable();

    /**
     * Collection of WorkItemTabs
     */
    WorkItemTabsCollection: KnockoutObservableArray<any> = ko.observableArray([]);

    // Series information
    SerialText: KnockoutObservable<string> = ko.observable(null);

    // the original start date of the work item from the series
    RecurringOriginOccurenceStartDate: KnockoutObservable<string> = ko.observable();

    /**
      * Dictionary of permissions for each WorkItemCollection
      */
    WorkItemCollectionsPermission: any;
       
    // #endregion Propeties

    // #region Public Methods

    InitTabController(): JQueryPromise<void> {
        let def = $.Deferred<void>();
        super.InitTabController()
            .then(_ => {
                this.TabControllerAssignment = new TabController(false);
                def.resolve();
            });

        return def.promise();
    }

    DeferredCompleteCheck(): JQueryPromise<any> {
        let def = $.Deferred();
        let resultComplete = this.CompleteCheck();
        // CompleteCheck aufrufen
        if (resultComplete != null && resultComplete["then"] != null) {
            (<JQueryPromise<boolean>>resultComplete)
                .then((result) => when(this.CompleteCheckTab(this.TabController), this.CompleteCheckTab(this.TabControllerAssignment))
                    .then((resultTab, resultTabAssignment) => def.resolve(result && resultTab && resultTabAssignment)));
        }
        else {
            $.when(this.CompleteCheckTab(this.TabController), this.CompleteCheckTab(this.TabControllerAssignment))
                .then((resultTab, resultTabAssignment) => def.resolve(resultComplete && resultTab && resultTabAssignment));
        }
        return def.promise();
    };

    CompleteCheckTab(tabController: TabController): JQueryPromise<any> {
        let def = $.Deferred();
        if (tabController != null) {
            tabController.CompleteCheckTabs().then((resultTabs) => {
                def.resolve(resultTabs);
            });
        }
        else {
            def.resolve(true);
        }
        return def.promise();
    }

    /** 
     * Handle buttons from the toolbar
     */
    registerEvents() {
        this.TabPage.MenuEvents.push(this.Menu.registerEvent((value) => {
            if (this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case this.PermissionSave():
                        this.DeferredCompleteCheck().then((result) => {
                            if (result === true) {
                                this.Save();
                            }
                        });
                        break;
                    case this.PermissionRefresh():
                        this.BeforeRefresh();
                        break;
                    case this.PermissionDelete():
                        if (this.PrimaryWorkItemId()) {
                            this.ShowDeleteDialog();
                        }
                        else {
                            this.BeforeDelete();
                        }
                        break;
                    case this.PermissionQRCode():
                        this.GenerateQRCode();
                        break;
                    case 'WorkItemSerialEdit':
                        this.workItemSerialEdit();
                        break;
                    case 'WorkItemCopy':
                        this.WorkItemCopy();
                        break;
                }
            }
        }));
    }


    CompleteCheck = (): JQueryPromise<boolean> | boolean => {
        let def = $.Deferred();
        let resolveFlag = true;
        switch (this.WorkItemTypeId().toUpperCase()) {
            case WorkItemTypes.AuditPlan.toUpperCase():
            case WorkItemTypes.Task.toUpperCase():
                {
                    if (!this.StartDateHtml() || !this.EndDateHtml() || !this.Title()) {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                        resolveFlag = false;
                    }
                    break;

                }
            default:
                {
                    if (!this.Title()) {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                        resolveFlag = false;
                    }
                    break;
                }
        }

        if (this.SerialTaskDialogViewModel) {
            this.SerialDialogCompleteCheck(this.SerialTaskDialogViewModel, true)
                .then(result => def.resolve(result));
        }
        else {
            def.resolve(resolveFlag);
        }       

        return def.promise();
    }

    PerformRefresh(model?: any): JQueryPromise<void> {
        let def = $.Deferred<void>();

        super.PerformRefresh(model).done(_ => {
            this.SerialTaskDialogViewModel = null;
            this.SetAdditionalPermissions();
            this.SetWorkItemStatus();

            $.when(this.RefreshTab(this.TabControllerAssignment))
                .then(__ => {
                    def.resolve();
                });
        });

        return def.promise();
    }

    RefreshTab(tabController: TabController): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        if (tabController != null) {
            tabController.RefreshTabs()
                .then(_ => def.resolve(true));
        }
        else {
            def.resolve(true);
        }
        return def.promise();
    }

    Save(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);
        let def = $.Deferred<void>();

        Bao.post("WorkItem/SaveWorkItem", JSON.stringify({ model: this.MinimizeEntity(), workItemRecurringModel: ko.map.toJS(this.SerialTaskDialogViewModel) }), (value) => {
            this.HandleSaveResponse(value).then(() => {
                def.resolve();
            })

        });

        return def.promise();
    }


    HandleSaveResponse(response): JQueryPromise<void> {
        let def = $.Deferred<void>();
        this.SaveTime(response.Result);

        this.SaveTab(this.TabController, response.Result)
            .then(_ => {
                $.when(this.SaveTab(this.TabControllerAssignment, response.Result))
                    .then(__ => {
                        this.PerformRefresh(response.Model).then(() => {
                            def.resolve();
                        });
                    });
            });

        Bao.raiseEvent('user-tagging:save', {});
        return def.promise();
    }

    SaveTab(tabController: TabController, saveTime: any): JQueryPromise<void> {
        let def = $.Deferred<void>();
        if (tabController != null) {
            tabController.CommitTabs(saveTime).then(() => {
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    }

    InitUrl = (): string => {
        return "WorkItem/Init";
    }

    init = (): JQueryPromise<void> => {
        return this.Initialization()
            .then(() => {
                if (this.TabPage?.UrlData()?.WorkItemCollectionId !== undefined
                    && this.TabPage?.UrlData()?.WorkItemCollectionId !== null
                    && this.TabPage?.UrlData()?.WorkItemCollectionId !== 'null') {
                    this.WorkItemCollectionId(this.TabPage?.UrlData()?.WorkItemCollectionId);
                }

                if ((this.TabPage?.UrlData()?.WorkItemCollectionId === undefined || this.TabPage?.UrlData()?.WorkItemCollectionId === null || this.TabPage?.UrlData()?.WorkItemCollectionId === 'null')
                    && (Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.WorkItemCollectionId)))
                    && this.IsNew()) {
                    this.OpenWorkItemCollectionDialog();
                }
                else {
                    this.LoadWorkItemCollection();
                }

            })
            .then(() => this.InitTabController())
            .then(() => this.loadTabsAssignment(null));
    }

    /**
     * Assign this WorkItem directly to an ConfigurationItem if 
     * the ConfigurationItemId - Parameter is set in the route.
     */
    AddInitialConfigurationItem = () => {
        if (this.IsNew() &&
            this.TabPage?.UrlData()?.ConfigurationItemId !== undefined &&
            this.TabPage?.UrlData()?.ConfigurationItemId !== null &&
            this.TabPage?.UrlData()?.ConfigurationItemId !== 'null') {

            let configurationItemId = this.TabPage?.UrlData()?.ConfigurationItemId;
            let objectTab = ko.unwrap(this.TabController?.Tabs)?.find(tab => ko.unwrap(tab.Id)?.toLowerCase() == WorkItemTabIds.WORKITEM_TAB_OBJECT);

            if (objectTab != null) {

                if (ko.unwrap(objectTab.Loaded) == true) {
                    this.AddConfigurationItemAfterLoad(configurationItemId, objectTab);
                }
                else {
                    objectTab.Loaded.subscribe(() => 
                        this.AddConfigurationItemAfterLoad(configurationItemId, objectTab));

                    if (ko.unwrap(objectTab.PreLoad) != true) {
                        objectTab.PreLoad(true);
                    }
                }
            }   
        }
    }

    /**
     * Adds a specific ConfigurationItem to the WorkItem-Object-Tab 
     * after it was loaded propertly.
     */
    AddConfigurationItemAfterLoad = (configurationItemId, objectTab: TabPage) => {
        if (ko.unwrap(objectTab?.ViewModel) instanceof WorkItemObjectTab) {

            if (ko.unwrap(ko.unwrap(objectTab?.ViewModel)?.Initialized) == true) {
                this.AddConfigurationItemAfterInitialization(configurationItemId, ko.unwrap(objectTab?.ViewModel));
            }
            else {
                ko.unwrap(objectTab?.ViewModel).Initialized.subscribe(() => {
                    this.AddConfigurationItemAfterInitialization(configurationItemId, ko.unwrap(objectTab?.ViewModel));
                });
            }            
        }
    }

    /**
     * Adds a specific ConfigurationItem to the WorkItem-Object-Tab
     * after it was initialized propertly.
     */
    AddConfigurationItemAfterInitialization = (configurationItemId, viewModel: WorkItemObjectTab) => {
        viewModel?.SaveSearchItem({
            PrimaryKeyValue: configurationItemId
        });
    }

    /***
     * Open the dialog to choose the workitemcollections
     * 
     * */
    OpenWorkItemCollectionDialog = () => {
        
        let dialog = new WorkItemCollectionDialog(this);
        return dialog.OpenDialog().then((result) => {
            if (result != null) {
                this.WorkItemCollectionId(result.WorkItemCollectionId);
                this.WorkItemCollectionName(result.Title)
                this.WorkItemCollections(result);
                this.WorkItemCollectionSelectedId(this.WorkItemCollectionId());
                this.OpenWorkItemTypeDialog();
            } else {
                this.TabPage.DirtyFlag(false);
                this.TabPage.$TabController.RemoveTab(this.TabPage);

            }
        })
    }

    loaded = (): void => {
        super.loaded();
        this.SetAdditionalPermissions();
        this.SetWorkItemStatus();

    }

    // remove nonrequired properties
    MinimizeEntity = () => {
        let models = super.MinimizeEntity();
        for (let o in models) {
            if (typeof models[o] === "string" && (o == "StartDate" || o == "EndDate")) {
                delete models[o];
            }
        }
        return models;
    }

    // Menu workItemInProgress click Event
    WorkItemInProgress = (): void => {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgWorkItemInProgressQuestion"), 'yesno');
        dialog.DialogResult.subscribe((shouldInProgress) => {
            if (shouldInProgress) {
                this.TabPage.IsLoading(true);
                Bao.post('WorkItem/TaskStatusInProgress', JSON.stringify({
                    workItemId: this.WorkItemId()
                })).then((result: boolean) => {
                    if (result) {
                        this.ShowNotification("msgWorkItemInProgressSuccessful");
                        this.TabPage.DirtyFlag(false);
                        this.PerformRefresh();
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                });
            }
        });
    }

    /*
     * Validate serial task
     * */
    public SerialDialogCompleteCheck(dialogViewModel: WorkItemSerialDialogViewModel, skipWarnings: boolean) {
        let def = $.Deferred();
        if (!this.ValidateMandatorFieldsForSerialTask(dialogViewModel)) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            def.resolve(false);
            return;
        }

        Bao.post("WorkItemRecurring/ValidateModel", JSON.stringify({
            startDate: this.StartDateHtml(),
            model: ko.map.toJS(dialogViewModel)
        }), function (result) {
            if (result.Result) {
                if (!skipWarnings && result.Warning) {
                    const dialog = new BaoDialog(Bao.Session.ApplicationName, result.Message, 'yesno');
                    dialog.DialogResult.subscribe((dialogResult) => {
                        if (dialogResult) {
                            def.resolve(true);
                        }
                        else {
                            def.resolve(false);
                        }
                    });

                }
                else {
                    def.resolve(true);
                }
            }
            else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                def.resolve(false);
            }
        });

        return def.promise();
    }

    // Menu workItemFinish click Event
    WorkItemComplete = (): void => {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgWorkItemFinishQuestion"), 'yesno');
        dialog.DialogResult.subscribe((complete) => {
            if (complete) {
                this.TabPage.IsLoading(true);
                Bao.post('WorkItem/TaskStatusComplete', JSON.stringify({
                    workItemId: this.WorkItemId()
                })).then((result: boolean) => {
                    if (result) {
                        this.ShowNotification("msgWorkItemFinishSuccessful");
                        this.TabPage.DirtyFlag(false);
                        this.PerformRefresh();
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                });
            }
        });
    }

    // Check user permission for Change Task Status
    HasPermissionToChangeTaskStatus = (): void => {
        this.TabPage.IsLoading(true);
        Bao.post('WorkItem/HasPermissionToChangeTaskStatus', JSON.stringify({
            workItemId: this.WorkItemId()
        })).then((result: boolean) => {
            this.TabPage.IsLoading(false);
            if (result != undefined && result != null) {
                this.IsTaskStatusChangePermission(result);
                this.RefreshMenuButtonsPermissions();
            }
        });
    }

    // Refresh Menu Buttons Permissions
    RefreshMenuButtonsPermissions = () => {
        const isWorkItemInProgressEnable: boolean = this.IsTaskStatusChangePermission() && !(!this.IsNew() && (this.WorkItemStatusId() == WorkItemStatusIds.WORKITEM_INPROGRESS || this.WorkItemStatusId() == WorkItemStatusIds.WORKITEM_COMPLETED));
        const isWorkItemCompletedEnable: boolean = this.IsTaskStatusChangePermission() && !(!this.IsNew() && this.WorkItemStatusId() == WorkItemStatusIds.WORKITEM_COMPLETED);
        const canAddEditSeries: boolean = !(this.IsBasedOnVirtual() || (this.WorkItemId() !== this.PrimaryWorkItemId() && this.PrimaryWorkItemId()));

        this.Menu.permissionEnable({ ActionKey: "WorkItemInProgress", Enabled: isWorkItemInProgressEnable, Context: this.TabPage.Context() });
        this.Menu.permissionEnable({ ActionKey: "WorkItemComplete", Enabled: isWorkItemCompletedEnable, Context: this.TabPage.Context() });
        this.Menu.permissionEnable({ ActionKey: "WorkItemSerialEdit", Enabled: canAddEditSeries, Context: this.TabPage.Context() });
    }

    // Set WorkItem Status
    SetWorkItemStatus = () => {
        this.IsInProgress(this.WorkItemStatusId() == WorkItemStatusIds.WORKITEM_INPROGRESS);
        this.IsCompleted(this.WorkItemStatusId() == WorkItemStatusIds.WORKITEM_COMPLETED);
    }

    // Show Notification
    ShowNotification(messageKey: string, type?: string) {
        if (!type) {
            type = 'success';
        }
        let message = Bao.Session.GetMessage(messageKey);
        // HACK: show shouter if message is loaded ... ( boa extension is planned to get better code ... )
        if (message() !== "") {
            baoShouter.show(message(), type);
        }
        else {
            let sub = message.subscribe(function (msg) {
                baoShouter.show(msg, type);
                sub.dispose();
            });
        }
    }


    // Get WorkItemCollection
    LoadWorkItemCollection = () => {
        return Bao.post("WorkItemCollection/Get", JSON.stringify({
            id: this.WorkItemCollectionId(),
        })).done(collections => {

            if (collections !== undefined && collections !== null) {
                this.WorkItemCollectionName(collections?.Title)
                this.WorkItemCollectionSelectedId(collections?.WorkItemCollectionId);
                this.OpenWorkItemTypeDialog();
            }

        });
    };

    // Get WorkItemTypes
    loadWorkItemType = (workItemCollectionId: string) => {
        if (this.WorkItemTypeId == null) { 
            return Bao.post("WorkItem/GetWorkItemTypes", JSON.stringify({
                workItemCollectionId: workItemCollectionId,
            }))
                .done(types => {
                    if (types && types.length > 0) {
                        this.WorkItemTypeId(types[0].WorkItemTypeId);
                    }
                }
                );
        }
    };

    /**
     * Action on the element with information about the serial task
     **/
    SerialInformationEdit = _ => {
        if (this.WorkItemId() === this.PrimaryWorkItemId()) {
            this.workItemSerialEdit();
        }
        else if (this.PrimaryWorkItemId()) {
            baoRouter.setHash('WorkItem/' + this.PrimaryWorkItemId());
        }
    }

    /**
     * Displays a dialog on removing work items based on the series
     * */
    ShowDeleteDialog = (): JQueryPromise<void> => {
        this.TabPage.IsLoading(true);
        let def = $.Deferred();

        let serialQuestionDialog = null;
        let allOptionMessageName = null;

        let buttons: DialogButton[] = [];


        if (this.WorkItemId() === this.PrimaryWorkItemId()) {
            serialQuestionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteWorkItemSeriesAllQuestion"));
            allOptionMessageName = "msgYes";
        }
        else {
            serialQuestionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteWorkItemSeriesQuestion"));
            allOptionMessageName = "msgDeleteWorkItemSeriesAll";

            buttons.push({
                Title: Bao.Session.GetMessage("msgDeleteWorkItemSeriesThis"),
                Click: () => {
                    serialQuestionDialog.DialogResult(1);
                    serialQuestionDialog.Close();
                },
                Enabled: ko.observable(true)
            });
            buttons.push({
                Title: Bao.Session.GetMessage("msgDeleteWorkItemSeriesThisAndFollowing"),
                Click: () => {
                    serialQuestionDialog.DialogResult(2);
                    serialQuestionDialog.Close();
                },
                Enabled: ko.observable(true)
            });
        }
        buttons.push({
            Title: Bao.Session.GetMessage(allOptionMessageName),
            Click: () => {
                serialQuestionDialog.DialogResult(3);
                serialQuestionDialog.Close();
            },
            Enabled: ko.observable(true)
        });
        buttons.push({
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: () => {
                serialQuestionDialog.DialogResult(null);
                serialQuestionDialog.Close();
            },
            Enabled: ko.observable(true)
        });

        serialQuestionDialog.Buttons(buttons);

        serialQuestionDialog.Width(400);
        serialQuestionDialog.Open();
        serialQuestionDialog.Closed = () => {
            if (serialQuestionDialog.DialogResult() === 1) {
                this.DeleteThisOrFeature('WorkItem/DeleteFromSeries');
                def.resolve();
            }
            else if (serialQuestionDialog.DialogResult() === 2) {
                this.DeleteThisOrFeature('WorkItem/DeleteFutureOnesFromSeries');
                def.resolve();
            }
            else if (serialQuestionDialog.DialogResult() === 3) {
                this.DeleteAll();
                def.resolve();
            }
            else {
                def.reject();
            }
        };
        this.TabPage.IsLoading(false);
        return def.promise();
    }

    /**
     * Removes the current item and all following items based on RecurringOriginOccurenceStartDate and series id. 
     * */
    DeleteThisOrFeature = (url: string) => {
        this.TabPage.IsLoading(true);
        return Bao.post(url, JSON.stringify({ workItemPrimaryId: this.PrimaryWorkItemId(), startDate: this.RecurringOriginOccurenceStartDate() }), () => {
            this.TabPage.IsLoading(false);
            this.TabPage.DirtyFlag(false);
            window.baorequire(["Services/AppTabController"], (AppTabController) => {
                AppTabController.RemoveTab(this.TabPage);
            });
        })
            .always(_ => this.TabPage.IsLoading(false));
    }

    /**
     * Deletes the entire series along with the definition
     * */
    DeleteAll = () => {
        this.TabPage.IsLoading(true);
        return Bao.post('WorkItem/DeleteWholeSeries', JSON.stringify({ workItemPrimaryId: this.PrimaryWorkItemId() }), () => {
            this.TabPage.IsLoading(false);
            this.TabPage.DirtyFlag(false);
            window.baorequire(["Services/AppTabController"], (AppTabController) => {
                AppTabController.RemoveTab(this.TabPage);
            });
        })
            .always(_ => this.TabPage.IsLoading(false));
    }

    //Load WorkItem Tabs
    loadWorkItemTabs = (workItemTypeId: string) => {
        return Bao.post("WorkItem/GetWorkItemTabs", JSON.stringify({
            workItemTypeId: workItemTypeId,
        }))
            .done(tabCollection => {
                if (tabCollection && tabCollection.length > 0) {
                    this.WorkItemTabsCollection(tabCollection);
                }
            });
    }


    /***
  * Open the dialog to choose the workitem type
  * 
  * */
    OpenWorkItemTypeDialog = () => {
        if (this.IsNew() && !this.WorkItemTypeId()) {
            let workItemTypeDialog = new WorkItemTypeDialog(this);

            return workItemTypeDialog.OpenDialog().then((dialogResult) => {
                if (dialogResult != null) {
                    this.WorkItemTypeId(dialogResult.WorkItemTypeId);
                    this.WorkItemTypeName(dialogResult.WorkItemType);
                }
                else {
                    this.TabPage.DirtyFlag(false);
                    this.TabPage.$TabController.RemoveTab(this.TabPage);
                }
            })
        }
    }


    // #endregion Public Methods

    // #region Protected Methods

    /**
     *  Method is responsible for the model view initialization logic. It supports several cases including serial task.
     * */
    protected Initialization = (): JQueryPromise<void> => {
        const startDate = baoRouter.getRouteValue("startdate", this.TabPage);
        const id = this.TabPage.UrlData().id;
        let def = $.Deferred<void>();

        Bao.post("WorkItem/GetWorkItemSerialTaskId", JSON.stringify({ id: id }), (result) => {
            if (result.Result) {
                if (result.Result == id && !startDate) {
                    super.init().then(_ => def.resolve());
                }
                else {
                    this.IsEditingSerialTaskDefinition().then((editAsSerialTask) => {
                        this.TabPage.IsLoading(true);
                        if (editAsSerialTask) {
                            this.InitForSerialTask(result.Result).then(_ => def.resolve());
                        }
                        else {
                            this.InitNewBaseOnSerialTask(startDate).then(_ => def.resolve());
                        }
                    });
                }
            }
            else {
                super.init().then(_ => def.resolve());
            }
        });

        return def.promise();
    };

    /**
     * Initialization when serial task definition editions are selected.
     * */
    protected InitForSerialTask = (id: string): JQueryPromise<void> => {
        let def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        if (this.InitUrl() != "" && id) {
            Bao.post(this.InitUrl(), JSON.stringify({ id: id }), (model) => {
                ko.map.fromJS(model.Definition, this);
                ko.map.fromJS(model.Model, this, this.TabPage.DirtyFlag);
                this.TabPage.SessionTabId = this.SessionTabId();
                if (this.IsNew() || (this.TabPage.ObjectId() != this.PrimaryKeyValue())) {
                    this.TabPage.ObjectId(this.PrimaryKeyValue());
                }
                else {
                    this.TabPage.ObjectId.valueHasMutated(); //wegen routing / hash
                }
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };

    /**
     * Initializes a new work item based on the serial task and the passed date
     * */
    protected InitNewBaseOnSerialTask = (startDate: string): JQueryPromise<void> => {
        let def = $.Deferred<void>();
        if (startDate) {
            this.IsBasedOnVirtual(true);
            this.TabPage.IsLoading(true);
            Bao.post("WorkItem/InitBaseOnSerialTask", JSON.stringify({ id: this.TabPage.UrlData().id, startDateTime: startDate }), (model) => {
                ko.map.fromJS(model.Definition, this);
                ko.map.fromJS(model.Model, this, this.TabPage.DirtyFlag);
                this.TabPage.SessionTabId = this.SessionTabId();
                if (this.IsNew() || (this.TabPage.ObjectId() != this.PrimaryKeyValue())) {
                    this.TabPage.ObjectId(this.PrimaryKeyValue());
                }
                else {
                    this.TabPage.ObjectId.valueHasMutated(); //wegen routing / hash
                }
                def.resolve();
            });
        }
        else {
            super.init().then(_ => def.resolve());
        }
        return def.promise();
    }

    /**
     * if it returns true, it means that the user has chosen to edit the serial task definition.
     * */
    protected IsEditingSerialTaskDefinition = (): JQueryPromise<boolean> => {
        this.TabPage.IsLoading(true);
        let def = $.Deferred();

        let serialQuestionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgOpenTaskSerialQuestion"));
        serialQuestionDialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOpenTask"),
            Click: () => {
                serialQuestionDialog.DialogResult(false);
                serialQuestionDialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgOpenSeries"),
            Click: () => {
                serialQuestionDialog.DialogResult(true);
                serialQuestionDialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: () => {
                serialQuestionDialog.DialogResult(null);
                serialQuestionDialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
        serialQuestionDialog.Width(400);
        serialQuestionDialog.Open();
        serialQuestionDialog.Closed = () => {
            if (serialQuestionDialog.DialogResult() === true) {
                def.resolve(true);
            }
            else if (serialQuestionDialog.DialogResult() === false) {
                def.resolve(false);
            }
            else {
                def.reject();
                this.TabPage.$TabController.RemoveTab(this.TabPage);
            }
        };
        this.TabPage.IsLoading(false);
        return def.promise();
    }


    protected workItemSerialEdit() {
        this.TabPage.IsLoading(true);
        let dialog = new WorkItemSerialDialog(this);
        dialog.Show()
            .always(_ => this.TabPage.IsLoading(false));
        dialog.DialogResult.subscribe((dialogResult) => {
            if (dialogResult != null) {
                this.SerialTaskDialogViewModel = ko.map.fromJS(dialogResult);
                this.TabPage.DirtyFlag.setDirty();
            }
        });
    }

    /**
     * Copy a work item
     * */
    protected WorkItemCopy() {
        const yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCopyWorkItemQuestion"), "yesno");
        yesNoDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                this.TabPage.IsLoading(true);
                Bao.post("WorkItem/CopyWorkItem", JSON.stringify({
                    workItemId: this.WorkItemId()
                }), (response) => {
                    if (response && response.WorkItemCopyId) {
                        baoRouter.setHash('WorkItem/' + response.WorkItemCopyId);
                    } else {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCopyWorkItemError"), "info");
                    }
                }).always(() => {
                    this.TabPage.IsLoading(false);
                });
            }
        });
    }

    /**
     * Get the permissions object for the current selected WorkItemCollection
     * */
    protected LoadPermission = () => {
        return Bao.post("WorkItemCollection/GetPermissions", JSON.stringify({
            workItemCollectionId: this.WorkItemCollectionId(),
        }))
            .then(result => {
                this.WorkItemCollectionsPermission = result.Permissions;
            }
        );
    }
    /**
     * Shows/Hides toolbar buttons for the current BriefingBook permissions (RoleShiftbooks)
     * */
    protected SetPermissions = () => {
        let def = $.Deferred();
        this.LoadPermission()
            .then(_ => {
                if (!this.WorkItemCollectionsPermission) {
                    return;
                }
                for (let actionKey in this.WorkItemCollectionsPermission) {
                    BaoMenu.permissionVisible({ ActionKey: actionKey, Context: this.TabPage.Context(), Visible: this.WorkItemCollectionsPermission[actionKey] });
                }
                def.resolve();
            });
        return def.promise();      
    }

    /**
     * Sets additional permissions
     * */
    protected SetAdditionalPermissions = () => {
        // Disable the WorkItem copy button when the WorkItem is new
        this.Menu.permissionEnable({ ActionKey: "WorkItemCopy", Enabled: !this.IsNew(), Context: this.TabPage.Context() });
        this.HasPermissionToChangeTaskStatus();
    }

    // #endregion Protected Methods

    // #region Private Methods

    //Tabs configuration
    protected loadTabsAssignment = _ => {
        this.AssignmentTab = new TabPage(null);
        this.AssignmentTab.IsClosable(false);
        this.AssignmentTab.Url("WorkItemAssignment");
        this.AssignmentTab.AutoSelect = true;
        this.TabControllerAssignment.AddTab(this.AssignmentTab);
    }

    /**
     * Checks whether all mandatory fields for the serial task definition are filled in
     * */
    private ValidateMandatorFieldsForSerialTask = (dialogViewModel: WorkItemSerialDialogViewModel): boolean => {
        if ((dialogViewModel.EndOptionValue() === '1' && !dialogViewModel.EndTimeJs()) || (dialogViewModel.EndOptionValue() === '2' && !dialogViewModel.NumberOfOccurrences())) {
            return false;
        }
        return true;
    }

    // #endregion Private Methods
}

export default WorkItem;